/** biome-ignore-all lint/style/useNamingConvention: these properties come from the BE as snake_case */
import kebabCase from 'lodash/kebabCase';

// Utility function to convert title to kebab-case ID
export const titleToId = (title: string): string => kebabCase(title);

type AssetOptionsType = {
  autoPlay?: boolean | undefined;
  loop?: boolean | undefined;
  muted?: boolean | undefined;
  playsInline?: boolean | undefined;
};

export type AssetType = {
  href: string;
  srcSet: string[];
  dataQaId: string;
  text?: string;
  textVariant?: string;
  fontColor?: string;
  isVideo?: boolean;
  options?: AssetOptionsType;
  altText?: string;
};

export type SubCategoryType = {
  display_name: string;
  dataQaId: string;
  sub_groups?: unknown;
  categories?: CategoryType[];
  href?: string;
};

export type CategoryType = {
  display_name: string;
  dataQaId: string;
  href: string;
};

export type InvitationCategoryType = {
  title: string;
  href: string;
  dataQaId: string;
  mobileOnly?: string;
  dropdownLeftAligned?: boolean;
  linkColor?: string;
  assets: AssetType[];
  subCategories: SubCategoryType[];
  bannerUrl?: string;
  bannerText?: string;
};

export type GlobalNavItemType = {
  title: string;
  id: string;
  url: string;
  categories: InvitationCategoryType[];
};

// Updated type definition for MegaNav data structure
export type MegaNavDataType = {
  homeURL: string;
  globalNav: GlobalNavItemType[];
};

export type CategoryPositionType = {
  left: number;
};

export enum TabsEnum {
  INVITATIONS = 'invitations',
  CARDS = 'greeting-cards',
  SUS = 'signup-sheets',
  PRO = 'evite-pro',
}
